import { Mapper } from 'src/base/mapper'
import { AddressTypeEntity } from 'src/data/entities/client.entity'
import { AddressTypeModel } from 'src/domain/models/client.model'

export class AddressMapper extends Mapper<AddressTypeEntity, AddressTypeModel> {
	mapFrom(param: AddressTypeEntity): AddressTypeModel {
		return this.resultData(param)
	}

	mapTo(param: AddressTypeModel): AddressTypeEntity {
		return this.resultData(param)
	}

	resultData(param: AddressTypeEntity | AddressTypeModel) {
		return {
			addressId: param.addressId,
			addressType: param.addressType,
			clientId: param.clientId,
			productId: param.productId,
			addressPart1: param.addressPart1,
			addressPart2: param.addressPart2,
			subDistrictCode: param.subDistrictCode,
			districtCode: param.districtCode,
			provinceCode: param.provinceCode,
			province: param.province,
			zipCode: param.zipCode,
			countryCode: param.countryCode,
			phone: param.phone,
			mobile: param.mobile,
			fax: param.fax,
			notes: param.notes,
			isActive: param.isActive,
			createdByUserId: param.createdByUserId,
			location: param.location,
			locationName: param.locationName,
			companyName: param.companyName,
			custAccount: param.custAccount,
			uniqueName: param.uniqueName,
			taxId: param.taxId,
			invoiceEmail: param.invoiceEmail,
			email: param.email,
			seat: param.seat,
			maxSeat: param.maxSeat,
			isPrimary: param.isPrimary,
			fullAddress: param.fullAddress,
			branchNo: param.branchNo,
			isThaiCompany: param.isThaiCompany,
		}
	}
}
